export type I3Help = I3IepHelp;

export enum I3IepHelp {
  IepTeams = 'IEP Teams',
  IepIdr = 'Incomplete Data Report',
  IepReports = 'IEPs / Reports',
}
